import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

export const CurrencyAmount = ({ row }) => {
    const { i18n } = useTranslation();

    if (!row.amount) return null;

    return (
        <Typography>
            {row.amount.toLocaleString(i18n.language, {
                style: 'currency',
                currency: row.currency,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            })}
        </Typography>
    );
};
